module.exports = __webpack_public_path__ + "assets/images/novasport_5.fdad39c375ca600a220f656226dc359c.png";